import { Dialog, Button } from "@mui/material";
import { baseURL } from "../../../../config/api";
import colorConfigs from "../../../../config/colorConfigs";
import useDelete from "../../../../hook/useDelete";

type Props = {
    editPopup: boolean;
    hidePopup: () => void;
    deleteCreditCard: () => void;
    particularCreditDetails: any;
}

export default function DeleteCreditCard({ editPopup, hidePopup, deleteCreditCard, particularCreditDetails }: Props) {
    const { setDeletePopup, setData: setDeleteData }: any = useDelete();

    const deleteTheCreditCard = () => {
        setDeleteData({
            tilte: `Delete`,
            summary: `Are you sure you want to delete this Credit Card?`,
            isDelete: (callback: any) => {
                fetch(`${baseURL}creditCard?id=${particularCreditDetails?.id}`, {
                    method: 'DELETE',
                })
                    .then(() => {
                        deleteCreditCard();
                        callback();
                    })
                    .catch(() => {
                        callback();
                    });
            }
        });

        setDeletePopup(true);
    };

    return (
        <>
            <Dialog
                open={editPopup}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '800px',
                        width: '100%',
                        borderRadius: '16px',
                    },
                }}
            >
                <div className={`px-[24px] py-[20px] h-[calc(100vh-142px)] overflow-auto`}>
                    <div className="w-full bg-white p-4 rounded-md">
                        <div className="w-full mt-2">
                            <div className={`w-full`}>
                                <div className={`sticky top-0 z-10 flex justify-between items-center p-2 border-b border-secondary bg-white`}>
                                    <div className="flex items-center gap-1.5">
                                        <h2 className={`text-lg font-semibold text-secondary`}>Credit Card Info</h2>
                                    </div>

                                    <button
                                        onClick={hidePopup}
                                        className="absolute right-2 top-2 text-gray-500 hover:text-red-500 transition"
                                    >
                                        <span className="material-symbols-outlined text-[20px]">close</span>
                                    </button>
                                </div>


                                <div className="mt-2 p-2">
                                    <div className="w-full">
                                        <div className="grid grid-cols-2 gap-6">
                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-semibold text-secondary`}>Last 4 digits</span>
                                                    <span className={`text-sm text-secondary`}>....{particularCreditDetails?.creditCardNumber}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-semibold text-secondary`}>Brand</span>
                                                    <span className={`text-sm text-secondary`}>{particularCreditDetails?.brand}</span>
                                                </div>
                                            </div>

                                            <div className="space-y-4">
                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-semibold text-secondary`}>Expiration Date</span>
                                                    <span className={`text-sm text-secondary`}>{particularCreditDetails?.expirationDate}</span>
                                                </div>

                                                <div className="flex flex-col gap-1.5">
                                                    <span className={`text-xs font-semibold text-secondary`}>Cardholder's Name</span>
                                                    <span className={`text-sm text-secondary`}>{particularCreditDetails?.cardholderName}</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="sticky bottom-0 flex justify-start gap-4 p-4 bg-white z-10">
                                            <Button
                                                variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.cancel.bg,
                                                    border: colorConfigs.btn.cancel.border,
                                                    color: colorConfigs.btn.cancel.color

                                                }}
                                                onClick={hidePopup}
                                            >
                                                Close
                                            </Button>

                                            <Button variant="contained"
                                                sx={{
                                                    backgroundColor: colorConfigs.btn.delete.bg,
                                                }}
                                                onClick={deleteTheCreditCard}
                                            >
                                                Delete
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    )
}
